var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 24c0 9.389-7.611 17-17 17-5.651 0-10.658-2.757-13.75-7H13a1 1 0 1 0 0-2H8.996A16.925 16.925 0 0 1 7 24c0-9.389 7.611-17 17-17 5.651 0 10.658 2.757 13.75 7H35a1 1 0 1 0 0 2h4.004A16.925 16.925 0 0 1 41 24zM24 43c-6.824 0-12.808-3.598-16.159-9H1a1 1 0 1 1 0-2h5.761A18.928 18.928 0 0 1 5 24C5 13.507 13.507 5 24 5c6.824 0 12.808 3.598 16.159 9H47a1 1 0 1 1 0 2h-5.761A18.928 18.928 0 0 1 43 24c0 10.493-8.507 19-19 19zM3 7a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm40 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm-19 0a13 13 0 0 0-12.75 15.536 1 1 0 0 1-1.962.39A15 15 0 0 1 24 9a1 1 0 1 1 0 2zm14 12a1 1 0 0 1 1 1 15 15 0 0 1-17.926 14.712 1 1 0 0 1 .39-1.962A13 13 0 0 0 37 24a1 1 0 0 1 1-1zm-13-7a1 1 0 1 0-2 0v8.535l.445.297 6 4a1 1 0 0 0 1.11-1.664L25 23.465V16z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeTime);
export default __webpack_public_path__ + "static/media/welcome_time.b9851c54edeb7bcf0fea214014ba407b.svg";
export { ForwardRef as ReactComponent };